<template>
  <el-dialog
    :title="$t('sc.gallery.newFolderTitle')"
    :visible="visible"
    width="480px"
    append-to-body
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form
      ref="form"
      :model="form"
      label-position="top"
    >
      <el-form-item :label="$t('sc.gallery.parentFolder')">
        <el-cascader
          v-model="form.parentId"
          :placeholder="$t('sc.gallery.pleaseSelect')"
          :options="cleanedDirectoryTree"
          :props="cascaderProps"
          clearable
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item :label="$t('sc.gallery.folderName')">
        <el-input
          v-model="form.name"
          :placeholder="$t('sc.gallery.folderNamePlaceholder')"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button
        type="primary"
        :loading="submitting"
        @click="handleSubmit"
      >
        {{ $t('sc.gallery.confirm') }}
      </el-button>
      <el-button @click="handleClose">
        {{ $t('sc.gallery.cancel') }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import { createGalleryDirectory } from '_h/gallery'

export default {
  name: 'NewFolderDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    directoryTree: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      form: {
        parentId: '',
        name: ''
      },
      submitting: false
    }
  },
  computed: {
    cascaderProps() {
      return {
        value: 'id',
        label: 'name',
        children: 'children',
        emitPath: false,
        checkStrictly: true
      }
    },
    cleanedDirectoryTree() {
      const clean = (nodes) => {
        return nodes.map(node => {
          const item = { id: node.id, name: node.name }
          if (node.children?.length > 0) {
            item.children = clean(node.children)
          }
          return item
        })
      }
      return clean(this.directoryTree)
    }
  },
  methods: {
    handleClose() {
      this.form = { parentId: '', name: '' }
      this.$emit('update:visible', false)
    },

    async handleSubmit() {
      if (!this.form.name?.trim()) {
        this.$message.warning(this.$t('sc.gallery.folderNameRequired'))
        return
      }

      this.submitting = true
      try {
        const data = { name: this.form.name.trim() }
        if (this.form.parentId) {
          data.parentId = this.form.parentId
        }
        await createGalleryDirectory(this.$axios, data)
        this.$message.success(this.$t('sc.gallery.createFolderSuccess'))
        this.$emit('created')
        this.handleClose()
      } catch (error) {
        console.error('createFolder error:', error)
        this.$message.error(this.$t('sc.gallery.createFolderFailed'))
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>
